import moment from 'moment'

export function isSameDay(time1: string, time2: string): boolean {
  const moment1 = moment(time1)
  const moment2 = moment(time2)

  return moment1.isSame(moment2, 'day')
}
